import {
  assign_custom_form_component_name,
  attendance_approval_component_name,
  attendance_pending_table,
  branch_component_name,
  branch_location_form,
  client_component_name,
  contact_group_component_name,
  contacts_component_name,
  custom_field_component_name,
  custom_form_component_name,
  custom_status_form_component_name,
  department_component_name,
  employee_component_name,
  epf_wage_form_component_name,
  holiday_component_name,
  leave_application_component_name,
  leave_approval_component_name,
  leave_pending_table,
  leave_type_component_name,
  location_edit_form_component_name,
  location_group_component_name,
  priorities_component_name,
  professional_tax_form_component_name,
  profile_view_component_name,
  project_component_name,
  pt_settings_form_component_name,
  role_component_name,
  salary_form_component_name_benefits,
  salary_form_component_name_deduction,
  salary_form_component_name_earnings,
  salary_form_component_name_reimbursements,
  salary_policy_form_component_name,
  status_component_name,
  task_list_component_name,
  work_schedule_component_name,
} from "../../common/constant/Constants";
import { toTestIdPart } from "./testId";

/**
 * data-testid module for each form / table component name, so a module's
 * sidebar form and its table share one prefix (e.g. "leave-type").
 */
const TEST_ID_MODULES = {
  [department_component_name]: "department",
  [branch_component_name]: "branch",
  [employee_component_name]: "employee",
  [role_component_name]: "role",
  [work_schedule_component_name]: "work-schedule",
  [holiday_component_name]: "holiday",
  [leave_type_component_name]: "leave-type",
  [leave_application_component_name]: "leave-application",
  [leave_approval_component_name]: "leave-approval",
  [leave_pending_table]: "leave-pending",
  [attendance_approval_component_name]: "attendance-approval",
  [attendance_pending_table]: "attendance-pending",
  [custom_field_component_name]: "custom-field",
  [profile_view_component_name]: "profile-view",
  [epf_wage_form_component_name]: "epf-wage",
  [professional_tax_form_component_name]: "professional-tax",
  [salary_form_component_name_earnings]: "salary-earning",
  [salary_form_component_name_deduction]: "salary-deduction",
  [salary_form_component_name_benefits]: "salary-benefit",
  [salary_form_component_name_reimbursements]: "salary-reimbursement",
  [salary_policy_form_component_name]: "salary-policy",
  [location_edit_form_component_name]: "location-edit",
  [pt_settings_form_component_name]: "pt-settings",
  [branch_location_form]: "branch-location",
  [location_group_component_name]: "location-group",
  [custom_status_form_component_name]: "custom-status",
  [status_component_name]: "task-status",
  [priorities_component_name]: "task-priority",
  [contact_group_component_name]: "contact-group",
  [client_component_name]: "client",
  [project_component_name]: "project",
  [task_list_component_name]: "task",
  [contacts_component_name]: "contact",
  [custom_form_component_name]: "custom-form",
  [assign_custom_form_component_name]: "assign-custom-form",
};

export const testIdModuleFor = (componentName) =>
  TEST_ID_MODULES[componentName] || toTestIdPart(componentName);
